// 类目级联选择器
import {getBaseCategoryTopAnd1} from '@/servers/prod/center'

const cg_cascader = {
  state: () => ({
    base_Top_1: [], // 基础类目的顶级及1级类目 --- 用于设置主营类目弹窗
    loading_base_Top_1: false, // 是否正在异步请求基础类目的顶级及1级类目
  }),
  mutations: {
    setBase_Top_1 (state, category) {
      state.base_Top_1 = category
    },
    setLoading_base_Top_1 (state, bool) {
      state.loading_base_Top_1 = bool
    }
  },
  actions: {
    getBaseCategoryTopAnd1({commit}) {
      commit("setLoading_base_Top_1", true)
      getBaseCategoryTopAnd1().then(options => {
        commit("setBase_Top_1", options ? options : [])
        commit("setLoading_base_Top_1", false)
      }).catch(err => {
        console.log('actions-getBaseCategoryTopAnd1-error!###', err)
        commit("setLoading_base_Top_1", false)
      })
    }
  },
  getters: {
    base_Top_1(state) {
      return state.base_Top_1
    },
    base_Top_1_loading(state) {
      return state.loading_base_Top_1
    },
  }
}

export default cg_cascader
